import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpRequest } from '@angular/common/http';
import * as RoleModels from '../../models/roles/role';
import { EnvironmentService } from '../environment.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RoleService {

  constructor(private httpClient: HttpClient,
    private environmentService: EnvironmentService) { }

  public getRole(RoleId: number) {
    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };
    return this.httpClient.get<RoleModels.RoleObjectModel>(`${this.environmentService.getApiURL()}/roles/${RoleId}`);
  }

  public setRole(Role: RoleModels.RoleModel): Observable<RoleModels.RoleObjectModel> {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    return this.httpClient.post<RoleModels.RoleObjectModel>(`${this.environmentService.getApiURL()}/roles`, Role, options);
  }

  public getRoles() {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };
    return this.httpClient.get<RoleModels.RoleListModel>(`${this.environmentService.getApiURL()}/roles`, options);
  }

  public deleteRole(RoleId: number) {
    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };
    return this.httpClient.delete<RoleModels.RoleObjectModel>(`${this.environmentService.getApiURL()}/roles/${RoleId}`);
  }
}
